<template>
    <div id="tabela" class="position-inherit mt-2">
        <slot name="customizado">
            <tabela
                :fields="camposFormatados"
                :items="itens"
                :sortBy="ordenadoPor"
                :sortDesc="ordenacaoDecrescente"
                :theadClass="ocultaCabecalho ? 'd-none' : ''"
                :hover="hover"
                :tbodyTrClass="classeLinha"
            />
        </slot>
        <paginacao 
            v-if="possuiPaginacao"
            :meta="paginacao" 
        />
    </div>
</template>
<script>
import tabela from './ListaItensTabela'
import paginacao from './ListaItensPaginacao'
export default {
    components: {
        tabela,
        paginacao
    },
    props: {
        campos: {
            default() {
                return []
            }
        }, 
        itens: {
            default() {
                return []
            }
        }, 
        paginacao: {
            default() {
                return []
            }
        }, 
        ocultaCabecalho: {
            default: false
        },
        hover: {
            default: true
        }, 
        classeLinha: {
            default: null
        },
        possuiPaginacao: {
            default: true
        },
        refSave: {
            default: false
        }
    },
    data() {
        return {
            ordenadoPor: this.$parent.ordenadoPor,
            ordenacaoDecrescente: this.$parent.ordenacaoDecrescente
        }
    },
    computed: {
        camposFormatados() {
            if (this.campos.length == 0){
                return []
            }
            return this.campos.filter(field => field.visible !== false)
        }
    }
}
</script>
